import { Button } from '@/components/era-ui';
import { CheckIcon } from '@/components/era-ui/icons/CheckIcon';

export type ButtonOption<T = string | boolean> = {
  value: T;
  label: string;
};

type ButtonGroupProps<T = string | boolean> = {
  options: ButtonOption<T>[];
  value: T | undefined;
  onChange: (value: T) => void;
  name: string;
  className?: string;
};

export const ButtonGroup = <T extends string | boolean = string | boolean>({
  options,
  value,
  onChange,
  name,
  className = '',
}: ButtonGroupProps<T>) => {
  return (
    <div className={`flex flex-row flex-wrap gap-[8px] mt-[4px] ${className}`}>
      {options.map((option) => {
        const isSelected = value === option.value;
        return (
          <Button
            variant="secondary"
            key={`${name}-${String(option.value)}`}
            onClick={() => onChange(option.value)}
            className={`peer-focus-visible:m-0 ${
              isSelected ? 'bg-surface-primary-with-interactive-active hover:bg-surface-primary-with-interactive-active' : ''
            }`}
          >
            {option.label}
            {isSelected && (
              <CheckIcon className="ml-2" />
            )}
          </Button>
        );
      })}
    </div>
  );
};
